<!--
 * @Description: 新增/编辑关联对象表单组件
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-space :size="0" direction="vertical" class="ly-form-table-space">
    <template v-if="modulesItem?.businessData != 14">
      <!-- 关联对象 -->
      <div class="table-head">
        <div class="table-title">
          {{ modulesItem?.label || $t('关联对象表格') }}
          <span class="hint" v-if="modulesItem?.isRequired">*</span>
        </div>
        <div class="add-btn">
          <template v-for="btn in buttons" :key="btn.value">
            <!--新建  -->
            <jw-link v-if="btn.value == `${modulesItem?.businessData >= 200 ? modulesItem?.businessData : data.operationObj?.[modulesItem?.businessData]}` + ':add'" @click="addDetail">{{ btn.label }}</jw-link>
            <!-- 合同产品--添加报价单明细-->
            <jw-link v-if="btn.value == `contractProduct:addOrderDetail`" @click="updateDetail(1)">{{ btn.label }}</jw-link>
            <!-- 销售订单产品--添加报价单明细 -->
            <jw-link v-if="btn.value == `saleOrderProduct:addOrderDetail`" @click="updateDetail(2)">{{ btn.label }}</jw-link>
            <!-- 销售订单产品--添加合同明细 -->
            <jw-link v-if="btn.value == `saleOrderProduct:addContractDetail`" @click="updateDetail(3)">{{ btn.label }}</jw-link>
          </template>
        </div>
      </div>
      <fh-table :max-height="500" header-affixed-top :pagination="null" :loading="data.tableloading" :data="data.detailDataList?.length ? modulesItem?.fieldValue?.records : [{}]" :bordered="true" :columns="getColumns(modulesItem.modules)" class="ly-form-table-35">
        <!-- 操作插槽 -->
        <template #operation="{ row, rowIndex }">
          <template v-if="data.detailDataList?.length">
            <template v-for="btn in buttons" :key="btn.value">
              <!-- 编辑 -->
              <jw-link v-if="btn.value == `${modulesItem?.businessData >= 200 ? modulesItem?.businessData : data.operationObj?.[modulesItem?.businessData]}` + ':edit'" @click="editDetail(row, rowIndex)">{{ btn.label }}</jw-link>
              <!-- 删除 -->
              <jw-link v-else-if="btn.value == `${modulesItem?.businessData >= 200 ? modulesItem?.businessData : data.operationObj?.[modulesItem?.businessData]}` + ':delete'" @click="removeDetail(row, rowIndex)">{{ btn.label }}</jw-link>
              <!-- 复制 -->
              <jw-link v-else-if="btn.value == `${modulesItem?.businessData >= 200 ? modulesItem?.businessData : data.operationObj?.[modulesItem?.businessData]}` + ':copy'" @click="copyDetail(row)">{{ btn.label }}</jw-link>
            </template>
          </template>
        </template>
      </fh-table>
    </template>
    <!-- 14：退货单产品 -->
    <template v-else>
      <div class="add-btn">
        <template v-for="btn in buttons">
          <jw-link :key="btn.value" v-if="btn.value == `returnOrderProduct:add`" @click="addReturnOrder">{{ btn.label }}</jw-link>
        </template>
      </div>
      <fh-table sticky-header :pagination="null" :data="data.detailDataList?.length ? data.detailDataList : [{}]" :bordered="true" :columns="getColumns(modulesItem.modules, true)">
        <template v-for="(item, index) in getColumns(modulesItem.modules, true)" :key="index" #[item?.colKey]="{ row, rowIndex }">
          <template v-if="!data.detailDataList?.length">
            <div class="empty-text">-</div>
          </template>
          <!-- 退货标准价格 -->
          <template v-else-if="item.colKey == 'standardPrice'">
            <jw-input-number :min="1" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" :placeholder="$t('请输入')" @change="updateList($event, rowIndex, row[index])" v-model="row[index].fieldValue" />
          </template>
          <!-- 折后单价（含税） -->
          <template v-else-if="item.colKey == 'customerDiscountPrice'">
            <span>{{ row[index].fieldValue?.toFixed(Number(row[index]?.setting?.fieldExt) || 2) || '-' }}</span>
          </template>
          <!-- 折扣 -->
          <template v-else-if="item.colKey == 'customerDiscount'">
            <jw-input-number class="card-form-item-value" v-model="row[index].fieldValue" :placeholder="$t('请输入')" @input="(event) => getPrecisionNum(event, row[index])" :precision="getPrecision(row[index], precisionNum)" :min="0" @change="updateList($event, rowIndex, row[index])">
              <template #append>%</template>
            </jw-input-number>
          </template>
          <!-- 税率 -->
          <template v-else-if="item.colKey == 'taxRate'">
            <span>{{ row[index].fieldValue + '%' || '-' }}</span>
          </template>
          <!-- 币种 -->
          <template v-else-if="item.colKey == 'currencyType'">
            <jw-select :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="tools.isJSON(row[index]?.setting?.fieldExt) ? JSON.parse(row[index]?.setting?.fieldExt) : []" popup-container=".system-form-item" @change="returnCurrencyType"> </jw-select>
          </template>
          <!-- 退货时长 -->
          <template v-else-if="item.colKey == 'buyTime'">
            <jw-input-number :min="0" v-model="row[index].fieldValue" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" @change="updateList($event, rowIndex, row[index])" :placeholder="$t('请输入')"> </jw-input-number>
          </template>
          <!-- 退货数量 -->
          <template v-else-if="item.colKey == 'purchaseNum'">
            <jw-input-number :min="1" v-model="row[index].fieldValue" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" @change="updateList($event, rowIndex, row[index])" :placeholder="$t('请输入')"> </jw-input-number>
          </template>
          <!-- 退货开始日期 -->
          <template v-else-if="item.colKey == 'serviceStartDate'">
            <jw-date-picker v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :format="row[index]?.setting?.fieldExt" popup-container=".system-form-item" position="br" />
          </template>
          <!-- 退货结束日期 -->
          <template v-else-if="item.colKey == 'serviceEndDate'">
            <jw-date-picker v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :format="row[index]?.setting?.fieldExt" popup-container=".system-form-item" position="br" />
          </template>
          <!-- 是否开票 是否汇款 -->
          <template v-else-if="item.colKey == 'isInvoice'">
            <jw-select @change="callbackData(data.detailDataList)" :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="(tools.isJSON(row[index]?.setting?.fieldExt) && JSON.parse(row[index]?.setting?.fieldExt)) || []" popup-container=".system-form-item" allow-clear> </jw-select>
          </template>
          <template v-else-if="item.colKey == 'isPayment'">
            <jw-select @change="callbackData(data.detailDataList)" :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="(tools.isJSON(row[index]?.setting?.fieldExt) && JSON.parse(row[index]?.setting?.fieldExt)) || []" popup-container=".system-form-item" allow-clear> </jw-select>
          </template>
          <!-- 操作插槽 -->
          <template v-else-if="item.colKey == 'operation'">
            <template v-for="btn in buttons">
              <jw-link :key="btn.value" v-if="btn.value == `returnOrderProduct:delete`" @click="delReturnOrder(rowIndex)">{{ btn.label }}</jw-link>
            </template>
          </template>
          <template v-else>
            <template v-if="row[index]?.setting?.fieldType == 6">
              <xl-avatar
                v-if="row[index]?.fieldValue?.userId"
                :avatar="{
                  name: row[index]?.fieldValue?.userName || '',
                  url: row[index]?.fieldValue?.avatar,
                  id: row[index]?.fieldValue?.userId
                }"
                :size="22"
              />
              <template v-else>-</template>
            </template>
            <template v-else-if="row[index]?.setting?.fieldType == 12">
              {{ row[index]?.fieldValue?.label || row[index]?.customValue?.label || '-' }}
            </template>
            <template v-else>
              {{ row[index]?.fieldValue || '-' }}
            </template>
          </template>
          <span class="tips" v-if="data.detailDataList?.length && item.isRequired && (row[index].fieldValue == '' || row[index].fieldValue == null || row[index].fieldValue == undefined)">{{ data.fieldTypeList.indexOf(row[index]?.setting?.fieldType) != -1 ? `${$t('请输入')}${row[index]?.setting.fieldName}` : `${$t('请选择')}${row[index]?.setting.fieldName}` }}</span>
        </template>
      </fh-table>
      <add-order-detail ref="addOrderRef" @cb="getProductList"></add-order-detail>
    </template>
  </jw-space>
  <!-- 关联对象表格新增/编辑弹窗 -->
  <jw-modal titleAlign="start" :maskClosable="false" unmount-on-close :width="800" :visible="isAdd" :title="data.operation == 1 ? $t('新增') : $t('编辑')" @cancel="toggleAdd" class="add-table-modal">
    <jw-form :model="data.form" label-align="left" ref="formRef" @submit="handleSubmit">
      <jw-row :gutter="16">
        <template v-for="(item, index) in data.form.customForm" :key="item.id">
          <jw-col :span="item?.setting?.fieldType === 26 || item?.setting?.fieldType === 27 ? 24 : 12" :class="item?.setting?.fieldType === 27 ? 'sub-form-content' : ''">
            <jw-form-item asterisk-position="end" :field="`customForm.${index}.fieldValue`" :class="['system-form-item', item?.setting?.fieldType === 12 ? 'relevancy-input' : item.displayOneLine == 1 && item?.setting?.fieldType == 1 ? 'card-form-line' : '', item.displayOneLine == 2 ? 'one-third' : '', item.displayOneLine == 3 ? 'two-thirds' : '', item?.setting?.fieldType === 26 ? 'editor-form-item' : '']" :rules="item?.setting?.fieldKey === 'mobile' ? mobileRules : item?.setting?.fieldKey == 'buyTime' ? buyTimeRules(`customForm.${index}.fieldValue`, item?.setting.fieldName) : item.type == 20 ? rules(item) : ''" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '120px' }" label-col-flex="auto" class="form-label-text">
              <template #label>
                <template v-if="item.type == 20">
                  <xl-label-text :value="item.label" :row="1" />
                  <jw-tooltip v-if="item?.setting?.fieldKey == 'buyTime'">
                    <icon-question-circle size="15" style="margin-left: 2px" />
                    <template #content>
                      <p>{{ $t('tips.buyTime1') }}</p>
                      <p>1、{{ $t('tips.buyTime2') }}</p>
                      <p>2、{{ $t('tips.buyTime3') }}</p>
                      <p>3、{{ $t('tips.buyTime4') }}</p>
                      <p>4、{{ $t('tips.buyTime5') }}</p>
                      <p>{{ $t('tips.buyTimeTitle') }}</p>
                      <p>1、{{ $t('tips.buyTime6') }}</p>
                      <p>2、{{ $t('tips.buyTime7') }}</p>
                    </template>
                  </jw-tooltip>
                </template>
              </template>
              <!-- 产品名称 -->
              <template v-if="item?.setting?.fieldKey === 'productId' || item?.setting?.fieldKey === 'product'">
                <xl-association :type="modules?.type" :modules-item="item" :form-data="data.form.customForm" :placeholder="$t('请选择')" v-model="item.fieldValue" @change="productChange" />
              </template>
              <!-- 产品类型 -->
              <template v-else-if="item?.setting?.fieldKey === 'productType'">
                {{ item?.fieldValue || '-' }}
              </template>
              <!-- 标准价格 -->
              <template v-else-if="item?.setting?.fieldKey === 'price' || item?.setting?.fieldKey === 'standardPrice'">
                <jw-input-number :min="1" :precision="item?.setting.fieldExt ? Number(item?.setting.fieldExt) : 2" v-model="item.fieldValue" allow-clear @change="updatePrice(item, $event)" hide-button :placeholder="$t('请选择')" :ref="`customForm.${index}.fieldValue`">
                  <template #suffix>
                    <icon-plus-circle size="18" class="plus-icon" @click="choosePrice" />
                  </template>
                </jw-input-number>
              </template>
              <!-- 购买时长 -->
              <template v-else-if="item?.setting?.fieldKey === 'buyTime'">
                <jw-input-number @change="buyTimeChange" :precision="JSON.parse(item?.setting.fieldExt)?.numberFormat ? Number(JSON.parse(item?.setting.fieldExt)?.numberFormat) : 2" :min="0.1" v-model="item.fieldValue" allow-clear :parser="(value) => `${value}`.replace(/\$\s?|(,*)/g, '')" :placeholder="$t('请输入')">
                  <template #append>{{ tools.isJSON(data.timeList) ? JSON.parse(data.timeList)?.find((item) => item.value == data.timeUnit)?.label : '' }} </template>
                </jw-input-number>
              </template>
              <!-- 停服日期 -->
              <template v-else-if="item?.setting?.fieldKey === 'serviceEndDate'">
                <jw-date-picker v-model="item.fieldValue" :disabledDate="(current) => dayjs(current).isBefore(dayjs(data.startDate))" :placeholder="$t('请选择')" @change="updateModulesItem('', item)" class="system-form-item-fields" :format="item?.setting?.fieldExt" position="br" />
              </template>
              <!-- 禾风特殊处理 -->
              <!-- 预算/分成对象 -->
              <template v-else-if="userInfo.orgId == hfOrgId && modulesItem?.businessData == 215">
                <!-- 拆账金额 -->
                <template v-if="item?.setting?.fieldType === 16 && item?.setting?.fieldKey == 'amount_a5sm3f'">
                  <jw-input-number @change="paymentChange" class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(item?.setting?.fieldExt)" />
                </template>
                <!-- 拆账比例 -->
                <template v-else-if="item?.setting?.fieldType === 7 && (item?.setting?.fieldKey == 'number_K4ZA4t' || item?.setting?.fieldKey == 'number_DHDhnk')">
                  <jw-input-number v-if="JSON.parse(item?.setting?.fieldExt)?.numberFormat === '100'" :precision="3" v-model="item.fieldValue" class="system-form-item-fields" :placeholder="$t('请输入')" allow-clear hide-button disabled>
                    <template #append> % </template>
                  </jw-input-number>
                  <jw-input-number v-else-if="JSON.parse(item?.setting?.fieldExt)?.numberUnit" class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(JSON.parse(item?.setting?.fieldExt)?.numberFormat)" disabled>
                    <template #append>
                      {{ JSON.parse(item?.setting?.fieldExt)?.numberUnit || '' }}
                    </template>
                  </jw-input-number>
                  <jw-input-number v-else class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(JSON.parse(item?.setting?.fieldExt)?.numberFormat)" disabled />
                </template>
                <xl-update-fields v-else :modules="item" :formatData="data.form.customForm" @cb="updateModulesItem" :from="30" :errorDataMap="calcErrorMap" />
              </template>
              <!-- 履约义务对象 -->
              <template v-else-if="userInfo.orgId == hfOrgId && modulesItem?.businessData == 201 && item?.setting?.fieldKey == 'number_fix8ik'">
                <!-- 执行进度 -->
                <jw-input v-model="item.fieldValue" :placeholder="$t('请输入')" disabled class="system-form-item-fields" />
              </template>

              <template v-else>
                <template v-if="showFormTable">
                  <template v-if="item?.setting?.fieldKey === 'opportunityStage'">
                    <xl-update-fields :modules="stageModulesItem(item)" :formatData="data.form.customForm" :from="30" @cb="updateModulesItem" :errorDataMap="calcErrorMap" />
                  </template>
                  <!-- modules结构只有查找关联使用，其他不使用，尤其人员和部门，会把整个formatData反传重新覆盖掉当前表单数据 -->
                  <xl-update-fields v-else-if="item?.setting?.fieldType == 12 || item?.setting?.fieldType == 25" :modules="item" :formatData="[{ modules: data.form.customForm }]" :from="30" @cb="updateModulesItem" :errorDataMap="calcErrorMap" />
                  <!-- 子表单 (35)-->
                  <template v-else-if="item.type == '35'">
                    <ly-subform-table :type="data.type" :copy="data.copy" :viewId="viewId" :entity="entity" :modules="data.setEditSubForm == 0 ? item : modulesItem.modules?.find((el) => el.value == item.value)" :id="id" :from="30" :optype="data.setEditSubForm" :set-data-list="item?.modules || []" :mainForm="data.form.customForm" />
                  </template>
                  <xl-update-fields v-else :modules="item" :formatData="data.form.customForm" :from="30" @cb="updateModulesItem" :errorDataMap="calcErrorMap" />
                </template>
              </template>
            </jw-form-item>
          </jw-col>
        </template>
      </jw-row>
    </jw-form>
    <template #footer>
      <jw-button size="small" @click="toggleAdd">{{ $t('取消') }}</jw-button>
      <jw-button type="primary" size="small" :loading="loading" @click="formRef.handleSubmit(1)" v-if="data.operation == 1 && showNextButton">
        {{ $t('确定并添加下一条') }}
      </jw-button>
      <jw-button type="primary" size="small" :loading="loading" @click="formRef.handleSubmit(2)">{{ $t('确定') }}</jw-button>
    </template>
  </jw-modal>
  <!-- 选择产品价格弹窗 -->
  <xl-price ref="priceRef"></xl-price>
  <!-- 新建编辑走布局 -->
  <fh-add-edit ref="addEditRef" @cbResult="addCbFun" />
</template>

<script setup>
import addOrderDetail from '@/views/sales-order/return-order/add-order-detail/add-order-detail.vue';
import { computed, h, nextTick, provide, reactive, ref, resolveDynamicComponent, watch } from 'vue';
import { tools } from '@/utils/tools.js';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const emit = defineEmits(['cb']);
const formRef = ref();
const priceRef = ref(); //选择价格
import useViewFields from '@/hooks/view-fields';
import { phoneRegexp, oldLayoutUserIds } from '@/utils/const';
import { Message } from '@arco-design/web-vue';
import { publicService } from '@/api/';
import { useUserStore } from '@/store';
const { userInfo } = useUserStore(); //用户信息
import { hfOrgId } from '@/utils/const';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

import _ from 'lodash';
const route = useRoute();
const { rules, getFieldLabel, setEditFormTable, getComputeing, setReferenceFieldValue, referenceFieldValue } = useViewFields();
import useLoading from '@/hooks/loading';
const { loading, setLoading } = useLoading(false); //loading
const props = defineProps({
  modules: {
    //表格的字段信息
    type: Object,
    default: () => {}
  },
  formData: {
    //表格数据
    type: Object,
    default: () => {}
  },
  //30:新增 40：编辑
  type: {
    type: Number,
    default: null
  },
  copy: {
    //1：复制
    type: Number,
    default: null
  },
  entity: {
    type: Number || String,
    default: null
  },
  viewId: {
    type: Number || String,
    default: null
  },
  id: {
    //这条主数据的ID(只有编辑时有)
    type: Number || String,
    default: ''
  },
  btns: {
    //按钮合集
    type: Array,
    default: () => []
  }
});
const showFormTable = ref(true);
const _modules = props.modules?.modules?.filter((v) => v.value != props.modules?.associateKey && v.type != 40);
const inputList = [0, 1, 7, 11, 13, 16, 21, 23, 26];
//获取placeholder
const getPlaceholder = (m) => {
  let ret = null;
  if (inputList.includes(m?.setting?.fieldType)) {
    ret = t('请输入');
  } else {
    ret = t('请选择');
  }
  return ret;
};
_modules?.map((v) => {
  v['businessData'] = null;
  v['placeholder'] = getPlaceholder(v);
  if (v?.type == 35) {
    //子表单
    v?.modules?.forEach((k) => {
      k['businessData'] = null;
      k['placeholder'] = getPlaceholder(v);
    });
  }
});
// const buttons = ref(props.modules?.modules?.filter((v) => v.type == 40));
const buttons = computed(() => props.btns); //动态读取每次规则匹配后的权限
const modulesItem = ref(props.modules);
modulesItem.value.modules = _modules;
const calcErrorMap = ref(); // 计算字段错误集合
const data = reactive({
  type: computed(() => props.type || route.params?.type), //30: 新增 40：修改
  copy: computed(() => props.copy || route.params?.copy), //对象type
  customerId: '',
  //关联表单
  form: {
    customForm: [modulesItem.value.modules]
  },
  //商机产品
  productId: '',
  //报价单产品
  detailDataList: [],
  moduleList: modulesItem.value.modules,
  currencyType: '',
  operation: 1,
  setEditSubForm: 0, //0:新增，1：编辑
  //合同产品
  tableloading: false,
  priceSheetId: '',
  contractId: '',
  //退货产品
  productList: [],

  recordIndex: '',
  fieldTypeList: [0, 1, 7, 11, 13, 16, 21, 23, 26],
  signData: '', //签单额
  operationObj: {
    //操作按钮权限标识
    101: 'cluePool', //线索池
    1: 'clue', //线索
    2: 'customer', //客户
    3: 'businessOpportunity', //商机
    4: 'product', //产品
    6: 'priceSheet', //报价单
    7: 'priceSheetProduct', //报价单-产品
    8: 'contract', //合同
    9: 'contractProduct', //合同-产品
    10: 'saleOrder', //销售订单
    11: 'saleOrderProduct', //销售订单-产品
    12: 'afterSale', //售后服务
    13: 'returnOrder', //退货单
    14: 'returnOrderProduct', //退货单-产品
    16: 'dynamicRecord', //动态记录
    32: 'businessOpportunityProduct' //商机产品
  },
  timeList: [], //时长单位的下拉数据
  startDate: '', //开服日期
  isRequesting: true, //计算字段是否计算完
  isSubmitFlag: 0 //是否点击确定
});
// 所有数据（基本信息+关联表格）
const formDataWatch = ref(props.formData);
const initCustomerId = () => {
  formDataWatch.value.map((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'customerId') {
            data.customerId = list.fieldValue?.value || list.fieldValue;
          } else if (list?.setting.fieldKey == 'priceSheetId') {
            data.priceSheetId = list.fieldValue;
          } else if (list?.setting.fieldKey == 'contractId') {
            data.contractId = list.fieldValue;
          }
        }
      });
    }
  });
};
initCustomerId();
watch(
  () => props.formData,
  () => {
    formDataWatch.value = props.formData;
    initCustomerId();
  },
  { deep: true }
);

provide('globalParams', {
  customerId: computed(() => data.customerId), //退货单中的选择订单使用
  type: computed(() => data.type)
});
// 必填校验和数量限制校验
// const validateFormItems = () => {
//   let hasEmptyRequiredTable = false;
//   let hasLinkError = false;
//   let requiredErrorMessage = '';
//   const linkErrorMessage = '格式不正确,请以http:// 或 https:// 开头,且不能包含汉字!';

//   data.form.customForm?.forEach((module) => {
//     if (hasEmptyRequiredTable && hasLinkError) {
//             return;
//         }
//     if (module?.type == 35) {
//       // 子表单
//       const data = subFormModuleList.value?.[module.id];
//       // 必填校验
//       if (module.isRequired == 1 && (!data || data.length === 0)) {
//         requiredErrorMessage= module?.label ? `请至少添加一条【${module?.label}】数据！` : '请至少添加一条子表单数据';
//         // Message.warning(message);
//         hasEmptyRequiredTable = true;
//         return; // 跳出当前模块的循环
//       }
//       // 校验子表单或者关联表格超链接格式(二维数组)
//       if (!hasLinkError) {
//         data?.forEach((list) => {
//           // 如果已经发现必填或数量限制问题，跳出外层循环
//           if (hasLinkError) {
//             return;
//           }
//           list?.forEach((item) => {
//             if (item?.setting?.fieldType == 11 && item?.fieldValue && !tools.checkLink(item.fieldValue)) {
//               hasLinkError = true;
//               return; // 跳出当前模块的循环
//             }
//           });
//         });
//       }
//     }
//   });
//  if (hasEmptyRequiredTable) {
//         Message.warning(requiredErrorMessage);
//         return
//     }
//     if (hasLinkError) {
//         Message.warning(linkErrorMessage);
//         return
//     }
//   return { hasEmptyRequiredTable, hasLinkError };
// };
const validateFormItems = () => {
  const inputList = [0, 1, 7, 11, 13, 16, 23, 26]; // 请输入的字段
  // 遍历表单数据
  const getFormData = data.form.customForm;
  for (const module of getFormData || []) {
    // 遍历模块
    if (module?.type == 35) {
      //子表单
      const data = subFormModuleList.value?.[module.id];

      // 必填校验
      if (module.isRequired && (!data || data.length === 0)) {
        const requiredErrorMessage = module?.label ? `请至少添加一条【${module?.label}】数据！` : '请至少添加一条子表单数据';
        Message.warning(requiredErrorMessage);
        return {
          hasEmptyRequiredTable: true,
          hasOverTable: false,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }

      // 数量限制校验
      if (module.type == 35 && data && data.length > 300) {
        Message.warning('子表单数据最多添加300行！');
        return {
          hasEmptyRequiredTable: false,
          hasOverTable: true,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }

      // 校验子表单超链接格式(二维数组)
      for (const list of data || []) {
        for (const item of list || []) {
          if (item?.setting?.isRequired && (item.fieldValue === '' || item.fieldValue === null || item.fieldValue === undefined || (Array.isArray(item.fieldValue) && item.fieldValue?.length === 0))) {
            const waringMsg = inputList.includes(item?.setting?.fieldType) ? '请输入' + item?.setting?.fieldName : '请选择' + item?.setting?.fieldName;
            Message.warning(waringMsg);
            return {
              hasEmptyRequiredTable: false,
              hasOverTable: false,
              hasSubFormEmptyError: true,
              hasLinkError: false
            };
          }

          if (item?.setting?.fieldType === 11 && item?.fieldValue && !tools.checkLink(item.fieldValue)) {
            const linkErrorMessage = '格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!';
            Message.warning(linkErrorMessage);
            return {
              hasEmptyRequiredTable: false,
              hasOverTable: false,
              hasSubFormEmptyError: false,
              hasLinkError: true
            };
          }
        }
      }
    }
  }

  // 如果所有检查都通过，返回没有错误的结果
  return {
    hasEmptyRequiredTable: false,
    hasOverTable: false,
    hasSubFormEmptyError: false,
    hasLinkError: false
  };
};
const handleSubmit = ({ values, errors }, ref) => {
  console.log('values-------', values);
  if (!errors) {
    //文件未上传完给提示
    const incompleteFileList = [];
    data.form.customForm?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldType === 18) {
        if (item.fieldValue && item.filesList && item.fieldValue.length != item.filesList.length) {
          incompleteFileList.push(item.fieldValue);
        }
      }
    });

    if (incompleteFileList && incompleteFileList.length) {
      Message.warning(t('文件未上传完成,请稍后提交！'));
      return;
    }
    // 调用验证函数
    const validationResult = validateFormItems();
    if (validationResult.hasEmptyRequiredTable || validationResult.hasOverTable || validationResult.hasSubFormEmptyError || validationResult.hasLinkError) {
      // 如果校验未通过，则不再继续后续操作
      return false;
    }
    if (!data.isRequesting) {
      // Message.warning('数据计算中');
      data.isSubmitFlag = ref;
      setLoading(true);
      return false;
    }
    data.isRequesting = true;
    data.isSubmitFlag = 0;
    getDetailList(_.cloneDeep(data.form.customForm));
    if (ref == 1) {
      showFormTable.value = false;
      //清空使用表单的清空，不在使用赋值为''的逻辑，不然会引发特殊字段异常【本次调整原因：用户点击确定并继续添加后，下拉选择的数组值中有一个默认''清不掉】
      data.form.customForm.forEach((v) => {
        if ((v?.setting?.fieldType === 6 && v?.setting?.fieldKey != 'chargePerson') || v?.setting?.fieldType === 22) {
          v.setting['fv'] = [];
        }
        if (v?.setting?.fieldType === 18) {
          v.filesList = [];
          v.fieldValue = [];
        }
      });
      formRef.value?.resetFields();
      nextTick(() => {
        showFormTable.value = true;
      });
    } else {
      toggleAdd();
    }
  }
};
// 创建列配置
const createColumnConfig = (record, item) => {
  //如果是空数据显示行的话 直接设置透明度0的tr
  if (!Object.keys(record)?.length) return h('div', { style: 'opacity: 0;' }, '-');
  const fieldKey = item?.setting?.fieldKey;
  let fieldType = item?.setting?.fieldType;
  let fieldExt = item?.setting?.fieldExt;
  if (fieldType == 21) {
    fieldType = item?.setting?.business?.fieldType;
    fieldExt = item?.setting?.business?.fieldExt;
  }
  if (fieldType == 7) {
    //数字
    return !isNaN(parseFloat(record[fieldKey])) ? tools.getNumberShow(record[fieldKey], fieldExt) : '-';
  } else if (fieldType == 9) {
    //日期范围
    return Array.isArray(record[fieldKey]) ? record[fieldKey].join('~') : '-';
  } else if ([2, 3, 4, 5, 10].indexOf(fieldType) > -1) {
    return (record[fieldKey] && getFieldLabel(record[fieldKey], fieldExt, fieldType)) || '-';
  } else if (fieldType == 12) {
    return record[fieldKey]?.label || record[fieldKey]?.customValue?.label || record[fieldKey]?.fieldValueName || '-';
  } else if (fieldType === 16) {
    return !isNaN(parseFloat(record[fieldKey])) ? tools.formatPriceShow(record[fieldKey], fieldExt) : '-';
  } else if (fieldType == 18) {
    if (record[fieldKey]) {
      const cpm = resolveDynamicComponent('ly-attachment-list');
      return h(cpm, {
        fieldValue: JSON.stringify(record[fieldKey])
      });
    } else {
      return '-';
    }
  } else if (fieldType === 23) {
    //百分比
    return !isNaN(parseFloat(record[fieldKey])) ? tools.formatPercentageShow(record[fieldKey], fieldExt) + '%' : '-';
  } else if (fieldType === 24) {
    //计算类型
    if (fieldExt && tools.isJSON(fieldExt)) {
      const getFieldExt = JSON.parse(fieldExt);
      if (getFieldExt?.type == 6 || getFieldExt?.type == 16) {
        //6：汇总金额 16：金额
        return !isNaN(parseFloat(record[fieldKey])) ? Number(record[fieldKey]).toFixed(getFieldExt?.dataType) : '-';
      } else if (getFieldExt?.type == 23) {
        //百分比
        return !isNaN(parseFloat(record[fieldKey])) ? Number(record[fieldKey]).toFixed(getFieldExt?.dataType) + '%' : '-';
      } else if (getFieldExt?.type == 5 || getFieldExt?.type == 7) {
        // 数字
        return !isNaN(parseFloat(record[fieldKey])) ? parseFloat(record[fieldKey]).toFixed(getFieldExt?.dataType) : '-';
      } else {
        return record[fieldKey] ?? '-';
      }
    }
  } else if (fieldType == 25) {
    return record[fieldKey]?.customValue?.length > 0 && record[fieldKey]?.customValue?.[0]?.label ? record[fieldKey]?.customValue.map((v) => v?.label)?.join(',') : record[fieldKey]?.fieldValueName?.length > 0 ? record[fieldKey]?.fieldValueName.join(',') : '-';
  } else if (fieldType == 26) {
    const cpm = resolveDynamicComponent('ly-rich-text');
    return h(cpm, {
      fieldValue: record[fieldKey]
    });
  } else {
    return record[fieldKey] ?? '-';
  }
};
// 创建子表单列配置
const createChildColumns = (item, parentIndex) => {
  const colTypeChildren = [];
  item?.modules?.forEach((el, index) => {
    console.log(parentIndex, index);
    const childRender = (h, { row }) => {
      // console.log('row[parentIndex]', parentIndex, item, row);
      // const subFormData = row?.[parentIndex]?.modules;
      //如果是空数据显示行的话 直接设置透明度0的tr
      if (!Array.isArray(row) || !row?.length) {
        return h('div', { style: 'opacity: 0;' }, '-');
      }
      const subFormData = row?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey)?.modules;
      return h(
        'div',
        { class: 'child-table-container' },
        subFormData?.length > 0
          ? [
              ...subFormData.map((subFormRecord) => {
                return h('p', { class: 'child-table-container-second' }, createColumnConfig(subFormRecord, el));
              })
            ]
          : '-'
      );
    };
    const _title = el?.setting?.fieldName || el?.label;
    const getColType = {
      title: _title,
      colKey: el?.setting?.fieldKey || el?.value,
      fixed: item.businessData == 1 ? 'left' : undefined,
      width: _title?.length <= 5 ? 120 : _title?.length * 30,
      //   cellClass: index == 0 ? 'sub-form-table-border-left' : index == item?.modules?.length - 1 ? 'sub-form-table-border-right' : '',
      cell: childRender
    };
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};
// 对象表格获取字段
const getColumns = (fieldList, isReturn = false) => {
  const list = [];
  //   console.log('fieldList----', fieldList);
  if (modulesItem.value?.businessData == 14) {
    //退货单产品
    fieldList = fieldList.filter((v) => v.setting.fieldType !== 18);
    fieldList?.forEach((item) => {
      const k = item?.setting?.fieldKey; //字段标识
      const colType = {
        title: item?.setting?.fieldName,
        colKey: item?.setting?.fieldKey,
        ellipsis: false,
        fixed: item.businessData == 1 ? 'left' : '',
        isRequired: item.setting?.isRequired
      };
      let width = item.label.length <= 5 ? 120 : item.label.length * 30;
      if (k == 'customerDiscount' || k == 'standardPrice' || k == 'currencyType' || k == 'purchaseNum' || k == 'isInvoice' || k == 'isPayment' || k == 'serviceStartDate' || k == 'serviceEndDate') {
        width = 200;
      }

      list.push({ ...colType, width });
    });
    list.push({
      title: t('操作'),
      colKey: 'operation',
      fixed: 'right',
      cell: 'operation',
      colType: false,
      width: 180
    });
    return list;
  } else {
    fieldList?.forEach((item, index) => {
      const colType = {
        title: item?.setting?.fieldName,
        colKey: item?.setting?.fieldKey,
        // dataIndex: item?.setting?.fieldKey,
        ellipsis: true,
        tooltip: true,
        fixed: item.businessData == 1 ? 'left' : '',
        isRequired: item?.setting?.isRequired,
        width: item?.setting?.fieldName?.length <= 5 ? 120 : item?.setting?.fieldName?.length * 30,
        headerCellClass: item?.setting?.fieldType == 27 ? 'sub-form-table-border-font-color' : ''
      };
      let render = null;
      if (item?.setting?.fieldType == 27) {
        //子表单
        const childCols = createChildColumns(item, index);
        colType.children = childCols;
      } else {
        render = (h, { row }) => {
          return createColumnConfig(row, item);
        };
      }

      if (render && !isReturn) {
        colType.cell = render;
      }
      list.push({ ...colType });
    });
    if (buttons.value?.filter((v) => v.value.indexOf(':add') < 0)?.length > 0) {
      list.push({
        title: t('操作'),
        colKey: 'operation',
        fixed: 'right',
        cell: 'operation',
        colType: false,
        width: 180
      });
    }

    return list;
  }
};
// 参与了计算的字段--实时计算
const formulasChange = async () => {
  data.isRequesting = true;
  const getDetailModules = {
    id: modulesItem.value.id,
    businessData: modulesItem.value.businessData
  };
  //   console.log('data.form.customForm-----', data.form.customForm);
  const op = {
    viewId: props.viewId,
    entity: props.entity,
    formData: formDataWatch.value,
    detailList: data.form.customForm,
    type: data.type,
    id: props?.id || null, //这条数据的id
    from: 2,
    modulesItem: getDetailModules
  };
  data.isRequesting = false;
  const { detailList, errorMap } = await getComputeing(op);
  const getResult = detailList;
  calcErrorMap.value = errorMap;
  data.form.customForm = getResult;
  data.isRequesting = true;
};
watch(
  () => data.isRequesting,
  () => {
    if (data.isRequesting) {
      //计算字段已经计算完
      if (data.isSubmitFlag) {
        //点击了【确定】或者【确定并添加下一条】按钮
        getDetailList(_.cloneDeep(data.form.customForm));
        setLoading(false);

        if (data.isSubmitFlag == 2) {
          //确定
          toggleAdd();
        } else {
          data.isRequesting = true;
          data.isSubmitFlag = 0;
          //确定并添加下一条
          showFormTable.value = false;
          formRef.value?.resetFields();
          data.form.customForm.forEach((v) => {
            if ((v?.setting?.fieldType === 6 && v?.setting?.fieldKey != 'chargePerson') || v?.setting?.fieldType === 22) {
              v.setting['fv'] = [];
            }
            if (v?.setting?.fieldType === 18) {
              v.filesList = [];
              v.fieldValue = [];
            }
          });
          nextTick(() => {
            showFormTable.value = true;
          });
        }
      }
    }
  },
  { deep: true }
);
// 禾风特殊处理
//拆账金额
const paymentChange = () => {
  formDataWatch.value?.map((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'amount_c64546') {
            //签单额
            data.signData = list.fieldValue;
          }
        }
      });
    }
  });
  data.form.customForm?.map((item) => {
    if (item.type == 20) {
      if (item?.setting.fieldKey == 'number_K4ZA4t') {
        //拆账比例
        const signAmount = data.form.customForm?.find((el) => el.setting?.fieldKey == 'amount_a5sm3f')?.fieldValue; //拆账金额
        // console.log('signAmount---',signAmount)
        item.fieldValue = data.signData && Number(signAmount / data.signData);
      }
      if (item?.setting.fieldKey == 'number_DHDhnk') {
        //结算金额
        const paymentData = data.form.customForm?.find((el) => el.setting?.fieldKey == 'number_K4ZA4t')?.fieldValue; //拆账比例
        const amountData = data.form.customForm?.find((el) => el.setting?.fieldKey == 'amount_a5sm3f')?.fieldValue; //拆账金额
        // console.log('signAmount---',signAmount)
        item.fieldValue = Number(paymentData * amountData);
      }
    }
  });
};
// 此处是处理商机阶段在新建/复制时默认选择第一个
const stageModulesItem = (item) => {
  if (item.value === 'opportunityStage' && data.operation == 1) {
    // 两种方案：：：：(产品确认使用2)
    // 1.如果是复制或者新增，赋值默认值
    // newObj.fieldValue = newObj.defaultValue;
    // 2.如果是复制或者新增，永远赋值第一个阶段
    const ext = item.setting.fieldExt;
    const parseExt = tools.isJSON(ext) && JSON.parse(ext) && JSON.parse(ext)?.length && JSON.parse(ext)?.[0]?.value;
    item.fieldValue = parseExt;
  }
  return item;
};
// 其他字段子组件回调
const updateModulesItem = async (getformatData, modulesItem) => {
  if (userInfo.orgId == hfOrgId && props.modules?.businessData == 201 && modulesItem?.setting?.fieldKey == 'input_AtwHxj') {
    //禾风特殊处理 （履约义务对象中的执行链接字段）
    data.form.customForm?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldKey == 'number_fix8ik') {
        //执行进度（%）
        if (modulesItem?.fieldValue?.trim()) {
          item.fieldValue = 100;
        } else {
          item.fieldValue = 0;
        }
      }
    });
  }
  if (getformatData && getformatData?.value) {
    data.form.customForm = getformatData.value;
  }
  const findItem = data.moduleList?.find((el) => el?.setting?.fieldKey == modulesItem?.setting?.fieldKey);
  if (findItem?.setting?.idCalculationsFields) {
    //参与了计算
    formulasChange();
  }
  //更改时长单位(商机产品时长单位是：timeType，其他对象是：timeUnit)
  if (modulesItem?.setting?.fieldKey === 'timeUnit' || modulesItem?.setting?.fieldKey === 'timeType') {
    timeUnitChange(modulesItem.fieldValue);
  }
  //开服日期
  if (modulesItem?.setting?.fieldKey === 'serviceStartDate') {
    data.startDate = modulesItem?.fieldValue;
    // 停服日期
    const endDate = data.form.customForm?.find((i) => i?.setting?.fieldKey == 'serviceEndDate');
    if (endDate?.fieldValue && dayjs(endDate?.fieldValue).diff(modulesItem?.fieldValue, 'day') < 0) {
      // 给停服日期置空
      data.form.customForm?.map((v) => {
        if (v?.setting?.fieldKey === 'serviceEndDate') {
          v.fieldValue = '';
        }
      });
    }
  }

  if ([6, 22, 18].includes(parseInt(modulesItem?.setting?.fieldType))) {
    //人员或部门
    data.form.customForm?.forEach((item, index) => {
      if (item.type == 20) {
        if (item?.setting?.fieldKey == modulesItem.value) {
          formRef.value?.clearValidate([`customForm.${index}.fieldValue`]);
        }
      }
    });
  }
  if (modulesItem?.setting?.fieldType == 12 && modulesItem?.setting?.fieldExt) {
    //查找关联字段---//针对引用字段做处理
    await setReferenceFieldValue([{ modules: data.form.customForm }], modulesItem);
    data.form.customForm = referenceFieldValue?.value?.[0]?.modules;
  }
};
// 退货单产品相关
const addOrderRef = ref();
//删除
const delReturnOrder = (index) => {
  const delItem = data.detailDataList[index].find((v) => v.fieldKey == 'orderProductId')?.fieldValue?.value;
  data.productList?.forEach((item, index) => {
    if (item.orderProductId?.value == delItem) data.productList.splice(index, 1);
  });
  data.detailDataList.splice(index, 1);
  callbackData(data.detailDataList);
};
//添加明细
const addReturnOrder = () => {
  addOrderRef?.value.openDialog();
};

//退货标准价格,及折扣,退货数量,退货时长改变时
const updateList = async (val, rowIndex, record) => {
  data.rowIndex = rowIndex;
  if (record?.setting?.idCalculationsFields) {
    // 参与了计算的字段--实时计算
    const getDetailModules = {
      id: modulesItem.value.id,
      businessData: modulesItem.value.businessData
    };
    const op = {
      viewId: props.viewId,
      entity: props.entity,
      formData: formDataWatch.value,
      detailList: data.detailDataList[rowIndex],
      type: data.type,
      // id: data.id,
      from: 2,
      modulesItem: getDetailModules
    };
    const { detailList, errorMap } = await getComputeing(op);

    const getResult = detailList;
    calcErrorMap.value = errorMap;

    // console.log('得到结果', getResult);
    data.detailDataList[rowIndex] = getResult;
  }

  callbackData(data.detailDataList);
};
//退货单修改币种(为了更新基本信息的币种)
const returnCurrencyType = () => {
  callbackData(data.detailDataList);
};
//关联表格回调同步更新到主表里
const callbackData = (callbackData) => {
  emit('cb', {
    id: modulesItem.value.id,
    modules: callbackData
  });
};
// 子表回调同步更新到关联表格中
// 关联对象表格子表数据信息
const subFormModuleList = ref({});
const callbackSubFormData = (callbackData) => {
  subFormModuleList.value[callbackData?.id] = _.cloneDeep(callbackData.modules);
};

//退货单--获取所选订单产品
const getProductList = async (selectPoductList) => {
  //   console.log('所需产品', selectPoductList);
  selectPoductList.forEach((item) => {
    const findItem = data.productList?.find((v) => v.orderProductId?.value == item.orderProductId?.value);
    if (!findItem) {
      item.id = ''; //新增的产品
      data.productList.push(item);
    }
  });

  data.productList?.forEach((item) => {
    if (item.fieldValues) {
      item.fieldValues?.forEach((list) => {
        item[list.fieldKey] = list.fieldValue;
      });
    }
  });
  // const errorDataMap = ref();

  //   console.log(' data.productList', data.productList);
  data.detailDataList = setEditFormTable(data.moduleList, data.productList);
  //   console.log(' data.detailDataList', data.detailDataList);
  // 参与了计算的字段--实时计算
  const getDetailModules = {
    id: modulesItem.value.id,
    businessData: modulesItem.value.businessData
  };
  const op = {
    viewId: props.viewId,
    entity: props.entity,
    formData: formDataWatch.value,
    detailList: data.detailDataList,
    type: data.type,
    // id: data.id,
    from: 3,
    modulesItem: getDetailModules
  };
  const { detailList, errorMap } = await getComputeing(op);
  calcErrorMap.value = errorMap;

  // console.log('得到结果----', getResult);
  data.detailDataList = detailList;
  emit('cb', {
    id: modulesItem.value.id,
    modules: _.cloneDeep(data.detailDataList)
  });
};
/*************
 * 公共
 *************/
// 新增--明细
const addEditRef = ref();
const productEntity = ref([7, 9, 11, 14, 32]);
const dataBak = ref(null); //临时备份编辑和复制的数据
const addDetail = () => {
  data.operation = 1;
  if (!productEntity.value?.includes(parseInt(modulesItem.value?.businessData)) && !oldLayoutUserIds?.includes(userInfo.orgId)) {
    //如果不是XX产品对象，新建走布局
    dataBak.value = null;
    const params = {
      id: '',
      type: 30,
      viewId: -1,
      entity: modulesItem.value?.businessData,
      associateKey: modulesItem.value?.associateKey,
      copy: 0,
      isAssociated: true
    };
    addEditRef.value?.open(params);
    return false;
  }
  data.setEditSubForm = 0; //给子表的参数
  data.recordIndex = '';
  data.form.customForm = _.cloneDeep(modulesItem.value.modules);
  /************** 获取主表单负责人复制到关联对象表格负责人字段中 start ******************/
  let _chargePerson = null;
  let _fv = null;
  props.formData?.forEach((fd) => {
    if (fd?.modules?.length) {
      fd?.modules?.forEach((fdm) => {
        if (fdm?.setting?.fieldKey == 'chargePerson') {
          _chargePerson = fdm?.fieldValue;
          _fv = _.cloneDeep(fdm?.setting?.fv);
        }
      });
    }
  });
  /************** 获取主表单负责人复制到关联对象表格负责人字段中 end ******************/

  data.form.customForm?.map((item) => {
    //复制默认负责人
    if (item?.setting?.fieldKey == 'chargePerson') {
      item.fieldValue = _chargePerson;
      item.setting.fv = _fv;
    }
    //客户折扣 默认是100
    if (item?.setting?.fieldKey == 'discount' || item?.setting?.fieldKey == 'customerDiscount') {
      //折扣
      item.fieldValue = 100;
    }
    if (item?.setting?.fieldKey == 'currencyType' || item?.setting?.fieldKey == 'currency') {
      //币种
      item.fieldValue = '1';
    }
    if (item?.setting?.fieldKey == 'purchaseNum' || item?.setting?.fieldKey == 'totality' || item?.setting?.fieldKey == 'num') {
      //购买数量 //总数量
      item.fieldValue = 1;
    }
  });
  //新增的时候调用一次计算
  formulasChange();
  toggleAdd(); //显示弹窗
};
// 编辑和复制时处理数据
const processingData = (record) => {
  record?.forEach((item) => {
    if (item.type == 35 && item.modules?.length) {
      item.modules?.forEach((k) => {
        k?.forEach((el) => {
          if (el?.setting?.fieldType == 6) {
            //6.人员
            const _list = el?.setting?.fv?.userList && Array.isArray(el?.setting?.fv?.userList) ? el?.setting?.fv?.userList : [];
            el.fieldValue =
              _list?.length > 0
                ? _list?.map((u) => {
                    return u?.userName || u?.name || '';
                  })
                : [];
          }
          if (el?.setting?.fieldType == 22) {
            //22:部门
            const _list = el?.setting?.fv?.departList && Array.isArray(el?.setting?.fv?.departList) ? el?.setting?.fv?.departList : [];
            el.fieldValue =
              _list?.length > 0
                ? _list?.map((u) => {
                    return u?.departmentName || u?.name || '';
                  })
                : [];
          }
        });
      });
    }
  });
  return record;
};
// 编辑--明细
const editDetail = (record, index) => {
  data.operation = 0;
  data.setEditSubForm = 1; //给子表的参数
  data.recordIndex = index;
  const updateRecord = processingData(_.cloneDeep(record));
  if (!productEntity.value?.includes(parseInt(modulesItem.value?.businessData)) && !oldLayoutUserIds?.includes(userInfo.orgId)) {
    console.log(record, 'console.log(record');
    dataBak.value = record;
    //如果不是XX产品对象，编辑时判断是否有id，有id的话走id查询编辑逻辑，没有id则将当前数据传递过去进行编辑
    const params = {
      id: record?.[0]?.detailId,
      editRecord: record, //record?.[0]?.detailId ? undefined : record,
      type: record?.[0]?.detailId ? 40 : 30,
      viewId: -1,
      entity: modulesItem.value?.businessData,
      associateKey: modulesItem.value?.associateKey,
      copy: 0,
      isAssociated: true
    };
    addEditRef.value?.open(params);
    return false;
  }
  data.form.customForm = updateRecord;
  toggleAdd();
  if (userInfo.orgId == hfOrgId && modulesItem.value?.businessData == 215) {
    //禾风特殊处理
    paymentChange();
  }
};
//删除--明细
const removeDetail = (record, rowIndex) => {
  data.detailDataList.splice(rowIndex, 1);
  emit('cb', {
    id: modulesItem.value.id,
    modules: _.cloneDeep(data.detailDataList)
  });
};
//复制--明细
const copyDetail = (record) => {
  data.operation = 1;
  data.setEditSubForm = 1; //给子表的参数
  data.recordIndex = '';
  const _r = processingData(_.cloneDeep(record));
  if (!productEntity.value?.includes(parseInt(modulesItem.value?.businessData)) && !oldLayoutUserIds?.includes(userInfo.orgId)) {
    dataBak.value = record;
    //如果不是XX产品对象，复制时判断是否有id，有id的话走id查询复制逻辑，没有id则将当前数据传递过去进行复制
    const params = {
      id: record?.[0]?.detailId,
      editRecord: record, //record?.[0]?.detailId ? undefined : record,
      type: 30,
      viewId: -1,
      entity: modulesItem.value?.businessData,
      associateKey: modulesItem.value?.associateKey,
      copy: record?.[0]?.detailId ? 1 : 0,
      isAssociated: true,
      fromCopy: true
    };
    addEditRef.value?.open(params);
    return false;
  }
  _r.map((r) => {
    r['detailId'] = '';
    if (r?.type == 35) {
      //子表单
      r?.modules?.forEach((el) => {
        el?.forEach((item) => {
          item['detailId'] = '';
        });
      });
    }
  });
  data.form.customForm = _.cloneDeep(_r);
  toggleAdd(1);
};
const addCbFun = (res) => {
  const _resMerge = _.cloneDeep(res);
  if (dataBak.value?.length) {
    //如果有存在备份，则对没有字段信息进行补充,调过计算字段和引用字段 && ![21, 24].includes(r?.setting?.fieldType)
    dataBak.value.forEach((db) => {
      const _findIndex = res?.findIndex((r) => r?.value && r?.value === db?.value);
      if (_findIndex === -1) {
        _resMerge.push(db);
      }
    });
  }
  getDetailList(_resMerge);
};
// 更新数据
const getDetailList = (selectPoductList) => {
  selectPoductList?.forEach((v) => {
    if (v.type == 35 && v.modules?.length && subFormModuleList.value[v?.id]) {
      v.modules = _.cloneDeep(subFormModuleList.value[v?.id]);
    }
  });
  if (data.operation == 1) {
    //新增
    data.detailDataList.unshift(selectPoductList);
  } else {
    //编辑
    data.detailDataList[data.recordIndex] = selectPoductList;
  }
  emit('cb', {
    id: modulesItem.value.id,
    modules: _.cloneDeep(data.detailDataList)
  });
};
//添加明细：type：1销售合同添加报价单明细时 type：2销售订单添加报价单明细时 type：3销售订单添加合同明细时
const updateDetail = (type) => {
  let id = null;
  if (type == 1 || type == 2) {
    if (!data.priceSheetId) {
      Message.warning(t('请选择报价单') + '！');
      return;
    }
    id = data.priceSheetId;
  } else {
    if (!data.contractId) {
      Message.warning(t('请选择销售合同') + '！');
      return;
    }
    id = data.contractId;
  }
  getPriceSheetProduct(id, type);
};
//获取相关明细  //type：1销售合同添加报价单明细时 type：2销售订单添加报价单明细时 type：3销售订单添加合同明细时

const getPriceSheetProduct = async (id, type) => {
  data.tableloading = true;
  const params = {
    id: id,
    detailEntityId: type == 1 || type == 2 ? 6 : 8, //区分是从报价单还是从合同明细添加的明细（对应的entityId）
    entityId: type == 2 || type == 3 ? 10 : 8 //上传当前对象entityId
  };
  try {
    const res = await publicService.getDetailAutoFill(params);
    if (!res.error) {
      const records = _.cloneDeep(res?.result);
      records?.forEach((item) => {
        if (item?.productName && item?.productId) {
          item['productId'] = {
            label: item.productName,
            value: item.productId,
            business: 4,
            id: item.originBusinessId
          };
        }
        item.newOriginBusinessId = item.originBusinessId + '-' + item.sourceId; //（来源entityId和来源数据id才是唯一值）
      });
      // console.log('records----',records)
      // 确保detailDataList和records都已定义
      if (!data.detailDataList || !records) return;
      // 初始化一个Set来存储已处理的originBusinessId，以避免重复处理
      const processedIds = new Set();
      // 遍历data.detailDataList
      data.detailDataList?.forEach((item) => {
        const itemId = item[0].newOriginBusinessId;

        // 如果该originBusinessId尚未处理
        if (!processedIds.has(itemId)) {
          const matchingRecord = records?.find((record) => record.newOriginBusinessId === itemId);

          // 如果在records中找到了匹配项
          if (matchingRecord) {
            // 使用setEditFormTable处理匹配到的记录，并替换到当前位置
            data.detailDataList.splice(data.detailDataList.indexOf(item), 1, ...setEditFormTable(data.moduleList, [matchingRecord]));
            processedIds.add(itemId); // 标记该originBusinessId已处理
          }
        }
      });
      // 收集未在data.detailDataList中找到匹配的records项
      const unmatchedRecords = records?.filter((record) => !processedIds.has(record.newOriginBusinessId));
      // 将未匹配的项使用setEditFormTable添加到前面
      unmatchedRecords?.forEach((record) => {
        data.detailDataList.unshift(...setEditFormTable(data.moduleList, [record]));
      });

      // 参与了计算的字段--实时计算
      const getDetailModules = {
        id: modulesItem.value.id,
        businessData: modulesItem.value.businessData
      };
      const op = {
        viewId: props.viewId,
        entity: props.entity,
        formData: formDataWatch.value,
        detailList: _.cloneDeep(data.detailDataList),
        type: data.type,
        // id: data.id,
        from: 3,
        modulesItem: getDetailModules
      };
      // const getResult = await getComputeing(op);
      const { detailList, errorMap } = await getComputeing(op);
      calcErrorMap.value = errorMap;
      data.detailDataList = _.cloneDeep(detailList);
      data.tableloading = false;
      emit('cb', {
        id: modulesItem.value.id,
        modules: _.cloneDeep(data.detailDataList)
      });
      //   console.log('detailDataList----', data.detailDataList);
    } else {
      data.tableloading = false;
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (e) {
    data.tableloading = false;
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
/***************
 * 产品相关
 **************/
const choosePrice = () => {
  data.form.customForm?.map((item) => {
    if (item?.setting?.fieldKey === 'productId' || item?.setting?.fieldKey === 'product') {
      data.productId = item?.fieldValue || '';
    }
  });
  if (!data.productId) {
    Message.error(t('tips.changeProduct'));
    return;
  }
  priceRef.value.priceShow(data.productId); //显示价格弹窗
};
// 更新明细相关字段
const updateCustomForm = (record) => {
  data.form.customForm?.map((item, index) => {
    if (item?.setting?.fieldKey == 'currency' || item?.setting?.fieldKey == 'currencyType') {
      //币种
      item.fieldValue = record && record?.currency ? String(record?.currency) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'timeType' || item?.setting?.fieldKey == 'timeUnit') {
      //时长单位
      item.fieldValue = record && record?.timeType ? String(record?.timeType) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'unit' || item?.setting?.fieldKey == 'specificationUnit') {
      //规格
      item.fieldValue = record && record?.unit ? String(record?.unit) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'price' || item?.setting?.fieldKey == 'standardPrice') {
      //标准价格
      item.fieldValue = record && record?.price ? record?.price : item.fieldValue;
      if (item.fieldValue) {
        formRef.value?.clearValidate([`customForm.${index}.fieldValue`]);
      }
      if (item?.setting?.idCalculationsFields) {
        // 参与了计算的字段--实时计算
        formulasChange();
      }
    }
  });
};

//更新产品价格
const updatePrice = () => {
  priceRef.value.clearChecked(); //清空价格选中
  data.moduleList?.map((item) => {
    if ((item?.setting?.fieldKey == 'price' || item?.setting?.fieldKey === 'standardPrice') && item?.setting?.idCalculationsFields) {
      // 参与了计算的字段--实时计算
      formulasChange();
    }
  });
};

const providedMethods = {
  updateCustomForm: updateCustomForm,
  setCallbackData: callbackSubFormData
};

provide('methods', providedMethods);
// 切换产品名称
const productChange = async (v, e) => {
  data.productId = v;
  //   console.log("产品---",v,e)
  let modulesItem = {};
  if (data.productId) {
    // 把一些有关产品的字段都清空(价格，币种，时长单位，规格单位)
    const fieldKey = ['price', 'standardPrice', 'productType', 'currency', 'currencyType', 'timeUnit', 'timeType', 'unit', 'specificationUnit', 'buyTime', 'taxRate'];
    data.form.customForm.map((item) => {
      if (fieldKey.includes(item?.setting?.fieldKey)) {
        item.fieldValue = null;
      }
      if (item?.setting?.fieldKey == 'productId' || item?.setting?.fieldKey == 'product') {
        //产品名称
        item.customValue = _.cloneDeep(e?.length > 0 ? e[0] : { label: '', value: '' });
        modulesItem = item;
      }
      if (item?.setting?.fieldKey == 'productType') {
        //产品类型
        item.fieldValue = e[0]?.productType;
      }
      if (item?.setting?.fieldKey == 'taxRate') {
        //税率 百分比
        if (item.setting?.fieldType == 23) {
          item.fieldValue = (Number(e[0]?.taxRate) && tools.getPercentage(Number(e[0]?.taxRate))) || '';
        } else {
          item.fieldValue = Number(e[0]?.taxRate);
        }
      }
    });
    priceRef.value.clearChecked(); //清空价格选中
    priceRef.value.getProductPrice(data.productId); //获取产品价格
    if (modulesItem?.setting?.fieldType == 12 && modulesItem?.setting?.fieldExt) {
      //查找关联字段---//针对引用字段做处理
      await setReferenceFieldValue([{ modules: data.form.customForm }], modulesItem);
      data.form.customForm = referenceFieldValue?.value?.[0]?.modules;
    }
    formulasChange(); //调用一次计算
  }
};
//时长单位变更时，改变购买时长的非必填状态
const timeUnitChange = (timeUnit) => {
  data.form.customForm?.map((item) => {
    if (item?.setting?.fieldKey == 'buyTime') {
      item.isRequired = false;
    }
  });
  if (timeUnit) {
    data.form.customForm?.map((item) => {
      if (item?.setting?.fieldKey == 'buyTime') {
        item.isRequired = true;
      }
    });
  }
};
// 购买时长的校验规则
const buyTimeRules = (field, fieldName) => {
  const sign = data.form.customForm?.findIndex((item) => item?.setting?.fieldKey === 'timeUnit' && item.fieldValue);
  if (sign !== -1) {
    return { required: true, message: `请填写${fieldName}` };
  } else {
    formRef.value?.clearValidate([field]);
    return {};
  }
};

data.timeUnit = computed(() => data.form.customForm?.filter((i) => i?.setting?.fieldKey == 'timeUnit')[0]?.fieldValue); //时长单位
data.timeList = computed(() => data.form.customForm?.filter((i) => i?.setting?.fieldKey == 'timeUnit')[0]?.setting?.fieldExt); //时长的下拉数据
//购买时长
const buyTimeChange = () => {
  data.moduleList?.map((item) => {
    if (item?.setting?.fieldKey == 'buyTime' && item?.setting?.idCalculationsFields) {
      // 参与了计算的字段--实时计算
      formulasChange();
    }
  });
};
// 添加、编辑弹窗明细的显隐
const isAdd = ref(false);
const showNextButton = ref(true);
const toggleAdd = async (i) => {
  showNextButton.value = !i;
  isAdd.value = !isAdd.value;
  if (isAdd.value) {
    data.isRequesting = true; //计算字段是否计算完
    data.isSubmitFlag = 0; //是否点击确定
  }
};
// 手机号校验
const mobileRules = [
  { required: true, message: t('tips.phoneNumber') },
  { match: phoneRegexp, message: t('tips.phoneRules') }
];
//初始化编辑数据到modules
const setEditTableData = () => {
  if (modulesItem.value.type == 30 && modulesItem.value?.modules) {
    //组件表格
    data.moduleList = modulesItem.value?.modules;
    if (data.type == 40 || data.copy == 1) {
      //编辑
      const productList = modulesItem.value?.fieldValue?.records;
      if (modulesItem.value?.businessData == 14) {
        //退货单产品
        data.productList = productList || [];
      }
      data.detailDataList = setEditFormTable(data.moduleList, productList);
      nextTick(() => {
        //兼容复制，初始化的时候返回一次数据
        callbackData(data.detailDataList);
      });
    }
  }
};

setEditTableData();

//合同/订单中切换报价单,订单中切换合同需要有关明细清除
const setDetailProduct = async (entity) => {
  const tempDetailDataList = [];
  data.detailDataList?.forEach((item) => {
    if (item[0]?.detailEntityId != entity) {
      tempDetailDataList.push(item);
    }
  });
  data.detailDataList = tempDetailDataList;
  emit('cb', {
    id: modulesItem.value.id,
    modules: _.cloneDeep(data.detailDataList)
  });
  //   console.log('444444', entity);
};
defineExpose({
  setDetailProduct
});
</script>
<style scoped lang="less">
@import './ly-form-table.less';
</style>
<style lang="less">
.add-table-modal {
  .arco-modal-body {
    min-height: 300px;
    max-height: 750px;
  }

  .system-form-item .arco-form-item-content-flex {
    flex-direction: inherit;
  }
}

.sub-form-content {
  //子表单容器
  .system-form-item {
    display: flex;
    flex-direction: column;
  }
}
</style>
